import Image from "next/image";

type BrandMarkProps = {
  size?: number;
  className?: string;
  priority?: boolean;
};

export function BrandMark({
  size = 32,
  className,
  priority = false,
}: BrandMarkProps) {
  return (
    <Image
      src="/images/logos/award-party/logo.svg"
      alt="Award Party"
      width={size}
      height={size}
      className={className}
      priority={priority}
    />
  );
}
